import { Box, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import Main from './variants/client/Main';
import Invoices from './variants/client/Invoices';
import ReactLoading from 'react-loading';
import { generateClient } from 'aws-amplify/api';
import { Schema } from '../../../amplify/data/resource';

// @ts-ignore
type Client = Schema['User']['type'];

const apiClient = generateClient<Schema>();

const Client = ({ 
  userId, 
  onDialogStateChange 
}: { 
  userId: string;
  onDialogStateChange?: (isOpen: boolean) => void;
}) => {
  const theme = useTheme();

  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState('main');

  useEffect(() => {
    if (!userId) {
      return;
    }
    const fetchUser = async () => {
      setLoading(true);

      try {
        const response = await apiClient.models.User.get({ id: userId });

        setClient(response.data);
      } catch (error) {
        console.error('Error downloading agent info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  const handlePageChange = (newPage: string) => {
    setPage(newPage);
  };

  const handleBackToMain = () => {
    setPage('main');
  };

  return (
    <Box>
      {loading || client === null ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            backgroundColor: '#E7ECF2',
          }}
        >
          <ReactLoading
            type={'bubbles'}
            color={theme.palette.green.main}
            height={250}
            width={250}
          />
        </Box>
      ) : (
        <>
          {page === 'main' && (
            <Main 
              client={client} 
              onPageChange={handlePageChange}
              onDialogStateChange={onDialogStateChange}
            />
          )}
          {page === 'invoices' && (
            <Invoices onBack={handleBackToMain} />
          )}
        </>
      )}
    </Box>
  );
};

export default Client;
